/**
 * Chat Unread Count Hook
 */

import { useQuery } from "@tanstack/react-query"
import { apiClient } from "@/lib/api-client"

async function getChatUnreadCount(): Promise<number> {
  const response = await apiClient.get<{
    success: boolean
    data: { unreadCount: number }
    message: string
  }>("/api/conversations/unread-count")
  return response.data.data.unreadCount
}

export function useChatUnreadCount() {
  return useQuery({
    queryKey: ["chat-unread-count"],
    queryFn: getChatUnreadCount,
    refetchOnWindowFocus: true,
  })
}
